import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { IonButton, IonIcon, IonHeader, IonRow, IonText, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { colors } from 'kards-components';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'src/modules/card/context/theme';

const ToolbarWrapper = styled(IonToolbar)`
  background-color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Header = ({ title }) => {
  const theme = useTheme();
  const history = useHistory();

  return (
    <IonHeader color={colors[get(theme, 'color.backgroundHeader')]} id="main-content">
      <ToolbarWrapper color={colors[get(theme, 'color.backgroundHeader')]}>
        <IonRow className="ion-justify-content-between ion-align-items-center">
          <div
            style={{
              flex: 0.3,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <IonButton fill="clear" onClick={() => history.goBack()}>
              <IonIcon slot="icon-only" icon={arrowBack} color={get(theme, 'color.buttonHeaderColor')} />
            </IonButton>
            <IonText color={get(theme, 'color.buttonHeaderColor')} style={{ fontSize: '1.2em', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              {title}
            </IonText>
          </div>

          <div
            style={{
              flex: 0.3,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              padding: 0,
            }}
          />
        </IonRow>
      </ToolbarWrapper>
    </IonHeader>
  );
};

export default Header;
